<script lang="ts" setup>
import HeaderOrganizationSwitch from '@components/Header/HeaderOrganizationSwitch.vue'
import { computed, defineAsyncComponent } from 'vue'

import { useResponsive } from '@/composables/useResponsive'
import { useDocumentTitleStore } from '@/stores/documentTitleStore'
import { useSettingsStore } from '@/stores/settingsStore'
import { useSidebarStore } from '@/stores/sidebar.store'

const HeaderThemeSwitch = defineAsyncComponent(() => import('@components/Header/HeaderThemeSwitch.vue'))
// gorn-762 - Временно скрыть компонент с уведомлениями, на данный момент мы не используем данный компонент
// const HeaderToolbarNotification = defineAsyncComponent(() => import('@components/Header/HeaderToolbarNotification.vue'))
const HeaderToolbarUser = defineAsyncComponent(() => import('@components/Header/HeaderToolbarUser.vue'))
const HeaderToolbarHelpCenter = defineAsyncComponent(() => import('@components/Header/HeaderToolbarHelpCenter.vue'))

const documentTitleStore = useDocumentTitleStore()
const settingsStore = useSettingsStore()
const sidebarStore = useSidebarStore()
const { isMobile } = useResponsive()

const iconSize = computed(() => isMobile.value ? 24 : 28)
const gornSettings = computed(() => settingsStore.getSettings)
const documentTitle = computed(() => documentTitleStore.getDocumentTitle || 'Главная страница')
</script>

<template>
  <header :class="['header', { 'header--mobile': isMobile }]">
    <template v-if="!isMobile">
      <div class="header__heading">
        <h1
          class="header__title"
          :title="documentTitle"
        >
          {{ documentTitle }}
        </h1>
      </div>

      <div class="header__content">
        <HeaderOrganizationSwitch :icon-size="iconSize" />
        <HeaderThemeSwitch
          v-if="gornSettings?.AllowThemeChange"
          :icon-size="iconSize"
        />
        <HeaderToolbarHelpCenter
          v-if="gornSettings?.help?.EntriesTree?.length"
          :help="gornSettings.help"
        />
        <!--<HeaderToolbarNotification :icon-size="iconSize" />-->
        <HeaderToolbarUser />
      </div>
    </template>

    <template v-else>
      <VAppBarNavIcon
        aria-label="Открыть основное меню"
        data-prevent-hide-menu
        @click="sidebarStore.open()"
      />

      <span class="header__mobile-title">{{ documentTitle }}</span>

      <HeaderOrganizationSwitch :icon-size="iconSize" />
      <!--<HeaderToolbarNotification :icon-size="iconSize" />-->
      <HeaderThemeSwitch
        v-if="gornSettings?.AllowThemeChange"
        :icon-size="iconSize"
      />
    </template>
  </header>
</template>

<style lang="scss" scoped>
.header {
  position: relative;
  z-index: 20;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  min-height: var(--ui-header-height);
  padding: 10px 16px 10px 20px;
  color: var(--ui-text);
  background: var(--ui-surface-raised);
  border: 1px solid var(--ui-border);
  border-radius: var(--ui-radius-md);
  box-shadow: var(--ui-shadow-sm);
}

.header__heading {
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;
  overflow: hidden;
  min-width: 0;
}

.header__title {
  overflow: hidden;
  margin: 0;
  font-size: clamp(1.125rem, 1.5vw, 1.375rem);
  font-weight: 720;
  line-height: 1.25;
  text-overflow: clip;
  white-space: nowrap;
  mask-image: linear-gradient(to right, #000 calc(100% - 64px), transparent 100%);
  mask-repeat: no-repeat;
  -webkit-mask-image: linear-gradient(to right, #000 calc(100% - 64px), transparent 100%);
  -webkit-mask-repeat: no-repeat;
}

.header__content {
  display: flex;
  flex: 0 0 auto;
  align-items: center;
  justify-content: flex-end;
  min-width: 0;
}

.header--mobile {
  gap: 4px;
  min-height: var(--ui-header-height);
  padding: 6px 8px;
  border-width: 0 0 1px;
  border-radius: 0 0 var(--ui-radius-md) var(--ui-radius-md);
  box-shadow: var(--ui-shadow-md);
}

.header__mobile-title {
  flex: 1 1 auto;
  overflow: hidden;
  padding-left: 4px;
  font-weight: 700;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
